import { Section } from "./models/Section.ts";
import { SectionsRoutes } from "./enums/SectionsRoutes.ts";

export const Sections = [
    new Section(SectionsRoutes.HOME, {"en": "Home", "it": "Home"}),
    new Section(SectionsRoutes.ABOUT, {"en": "About", "it": "About"}),
    new Section(SectionsRoutes.ART, {"en": "Art", "it": "Arte"}),
    new Section(SectionsRoutes.TECH, {"en": "Tech", "it": "Tech"}),
    new Section(SectionsRoutes.CONTACT, {"en": "Contact", "it": "Contatti"}),
]